import { Link } from 'react-router-dom'
import { references } from '@/content/portfolio'

export function References({ preview = false, compact = false }: { preview?: boolean; compact?: boolean }) {
  const items = preview ? references.slice(0, 2) : references
  return (
    <section id="references" className="scroll-mt-24 border-t border-vibe-border py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <div className="section-label mb-3">References</div>
        <h2 className="text-3xl lg:text-4xl font-medium tracking-tight text-text-heading">People I’ve worked with</h2>
        <div className={compact ? 'mt-8 space-y-4' : 'mt-8 grid gap-5 md:grid-cols-2'}>
          {items.map((ref, index) => compact && index > 0 ? (
            <details key={ref.name} className="border-b border-vibe-border py-4">
              <summary className="cursor-pointer text-text-heading">{ref.name}<span className="mt-1 block text-sm text-text-secondary">{ref.role}</span></summary>
              <blockquote className="mt-4 max-w-3xl text-[15px] leading-relaxed text-text-secondary">“{ref.quote}”</blockquote>
              <p className="mt-3 font-mono text-xs text-text-secondary">{ref.relationship} · {ref.date}, LinkedIn</p>
            </details>
          ) : (
            <figure key={ref.name} className="flex flex-col rounded-xl border border-vibe-border bg-card-bg p-5 lg:p-6">
              <blockquote className="flex-1 text-[15px] leading-relaxed text-text-secondary">
                “{preview ? `${ref.quote.split(/(?<=\.)\s/).slice(0, 2).join(' ')} …` : ref.quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-vibe-border pt-4">
                <div className="font-medium text-text-heading">{ref.name}</div>
                <div className="mt-1 text-sm text-accent-primary">{ref.role}</div>
                <div className="mt-2 font-mono text-xs leading-relaxed text-text-muted">{ref.relationship} · {ref.date}, LinkedIn{preview && ' · Excerpt'}</div>
              </figcaption>
            </figure>
          ))}
        </div>
        {preview && <Link to="/about#references" className="mt-8 inline-block text-base text-accent-primary underline underline-offset-4 hover:text-text-primary">Read all references</Link>}
      </div>
    </section>
  )
}
